import { useState, useEffect } from "react";
import { ReactSession } from "react-client-session";
// import { useStripe } from "@stripe/react-stripe-js";
import axios from "axios";
import {
  Box,
  Text,
  Stack,
  Flex,
  Button,
  HStack,
  Container,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  Badge
} from "@chakra-ui/react";
import MainStyles from "../../resources/css/css.module.css";
import LoadingStyles from "../../resources/css/loadingAnime.module.css";
import { BeatLoader } from 'react-spinners';
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { linksConfig } from "../../utils/CommonLinks";

const ACCEPT_PLANS = ["HACK","LAUNCH","SCALE","BUILD","GROW","ACCELERATE"];

const Billings = (props) => {
    // const stripe = useStripe();
    // const backendStripe = new Stripe('',{
    //     apiVersion:"2022-11-15",
    // });
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const [isLoading, setLoading] = useState(true);
    const [errOcc, setErrOcc] = useState(false);
    const [data, setData] = useState([]);
    const [userCards, setUserCards] = useState([]);

    const [cardPlan,setCardPlan] = useState("");
    const [cardUpdateLoading, setCardUpdateLoading] = useState(false);
    const [cardUpdateError,setCardUpdateError] = useState(""); 

    const [cardCancelled,setCardCancelled] = useState('');
    const [planCancelled,setPlanCancelled] = useState('');
    const [planCancelName,setPlanCancelName] = useState('');
    const [cancelStatus,setCancelStatus] = useState("NO_ACTION");

    const [errorWhileCancelPlan, setErrorWhileCancelPlan] = useState(false);

    const [showCancelCard,setShowCancelCard] = useState(false);
    const [gRPCExpiry,setgRPCExpiry] = useState('');

    const [reasons,setReasons] = useState([]);
    const [cancelInput,setCancelInput] = useState("");
    const [enableCancelInput, setEnableCancelInput] = useState(false);
    const [selProvider,setSelectProvider] = useState('');
    const [textProvider,setTextProvider] = useState('');
    const [showProviderBox,setShowProviderBox] = useState(false);
    const [showTextProviderBox,setShowTextProviderBox] = useState(false);

    const [issueInput, setIssueInput] = useState("");
    const [enableIssueInput, setEnableIssueInput] = useState(false);
    const [featureInput, setFeatureInput] = useState("");
    const [enableFeatureInput,setEnableFeatureInput] = useState(false);


    
    useEffect(() => {
        const token = ReactSession.get("xTkn") ?? "";
        if (token !== "") {
            const endPoint = process.env.REACT_APP_AUTH_EP;
            axios({
                url: `${endPoint}dashboard/card`,
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    "ngrok-skip-browser-warning": "69420",
                }
            })
                .then((res) => {
                    if (res.data.success === true && res.data.result.length > 0) {
                        const cards = [];
                        cards.push(res.data.result[0]);
                        setUserCards(cards);
                    }
                })
                // Catch errors if any
                .catch((err) => {
                    console.warn(err);
                    
                });
        }
    }, [props.isFreeUser])

    /*
    const removeCard = (id) => {
        setCardCancelled(id);
        // document.getElementById("remLoad").disabled = true;
        // document.getElementById("remLoad").innerHTML = `<div class=${LoadingStyles.lds_ripple}><div></div><div></div></div>`;
        const endPoint = process.env.REACT_APP_AUTH_EP;
        const token = ReactSession.get("xTkn") ?? "";
        axios({
            url: `${endPoint}dashboard/card?payment_method_id=${id}`,
            method: "DELETE",
            headers: {
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "69420",
            }
        })
            .then((res) => {
                if (res.data.success === true) {
                    setUserCards([]);
                    props.setCurrentPlan("FREE");
                    ReactSession.set("ifr", "FREE");
                }
                else {
                    document.getElementById("remLoad").innerHTML = "Cancel Plan";
                    document.getElementById("remLoad").disabled = false;
                }
            })
            // Catch errors if any
            .catch((err) => {
                console.warn(err);
                document.getElementById("remLoad").innerHTML = "Cancel Plan";
                document.getElementById("remLoad").disabled = false;
                
            });
    }
    */

    
    const updatePaymentMethod = (planName) => {
        // setCardCancelled(id);
        // document.getElementById("remLoad").disabled = true;
        // document.getElementById("remLoad").innerHTML = `<div class=${LoadingStyles.lds_ripple}><div></div><div></div></div>`;
        const endPoint = process.env.REACT_APP_AUTH_EP;
        const token = ReactSession.get("xTkn") ?? "";
        setCardUpdateError("");
        if(token === "") {
            setCardUpdateError("NO_TOKEN");
            return;
        }
        if(!planName) {
            setCardUpdateError("NO_PLAN");
            return;
        }
        setCardUpdateLoading(true);
        axios({
            url: `${endPoint}dashboard/card_update_url`,
            method: "GET",
            headers: {
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "69420",
            },
            params: {
                plan_name: planName
            }
        })
            .then((res) => {
                setCardUpdateLoading(false);
                if (res.data.success === true) {
                    const updateUrl = res.data.result?.checkout_url;
                    if(updateUrl)
                        window.location.replace(updateUrl);
                    else
                        setCardUpdateError("ERROR");
                }
                else {
                     setCardUpdateError("ERROR");
                }
            })
            // Catch errors if any
            .catch((err) => {
                console.warn(err);
                setCardUpdateLoading(false);
                setCardUpdateError("ERROR");
            });
    }
    

    
    const cancelPlanNow = (id) => {
        const cancelReasons = reasons;
    
        if(enableCancelInput && cancelInput !== '') 
            cancelReasons.push(cancelInput);

        if(enableFeatureInput && featureInput !== '' && featureInput.length > 3)
            cancelReasons.push("Feature: " + featureInput);

        if(enableIssueInput && issueInput !== "" && issueInput.length > 3)
            cancelReasons.push("Issue: "+issueInput)

        if(textProvider !== '') {
            cancelReasons.push("Switched to other provider "+textProvider);
        }
        else if(selProvider !== '') {
            cancelReasons.push("Switched to "+selProvider);
        }

        setCancelStatus("CANCELLING");
        const endPoint = process.env.REACT_APP_AUTH_EP;
        const token = ReactSession.get("xTkn") ?? "";
        axios({
            url: `${endPoint}dashboard/cancel_plan`,
            method: "POST",
            headers: {
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "69420",
            },
            data: {
                plan_id: id,
                cancel_reason: reasons.join(',')
            }
        })
            .then((res) => {
                
                if (res.data.success === true) {

                    const planBeingCancelled = data.find(plan => plan.plan_id === id);
                    const currentPlans = data.filter(plan => plan.plan_id !== id);
                    planBeingCancelled.cancel_at_cycle_end = true;
                    currentPlans.push(planBeingCancelled);
                    setData(currentPlans);
                    setCancelStatus("CANCELLED");
                    setPlanCancelled('');
                    setTimeout(() => {
                        setCancelStatus("NO_ACTION");
                        setShowCancelCard(false);
                    }, 1000);
                    // props.setCurrentPlan("FREE");
                    // ReactSession.set("ifr", "FREE");
                }
                else {
                    setErrorWhileCancelPlan(true);
                    setPlanCancelled('');
                    setCancelStatus("NOT_CANCELLED");
                    setTimeout(() => {
                        setCancelStatus("NO_ACTION");
                        setShowCancelCard(false);
                    }, 1000);
                }
            })
            // Catch errors if any
            .catch((err) => {
                console.warn(err);
                setErrorWhileCancelPlan(true);
                setPlanCancelled('');
                setCancelStatus("NOT_CANCELLED");
                setTimeout(() => {
                    setCancelStatus("NO_ACTION");
                    setShowCancelCard(false);
                }, 1000);
            });
    }
    


    // useEffect(() => {
    //     const token = ReactSession.get("xTkn") ?? "";
    //     const isFree = ReactSession.get("ifr") ?? "unknown";
    //     if (isFree === "Free")
    //         props.setFreeUser(true)
    //     else
    //         props.setFreeUser(false)
    //     if (token !== "") {
    //         const endPoint = process.env.REACT_APP_AUTH_EP;
    //         axios({
    //             url: `${endPoint}dashboard/billing`,
    //             method: "GET",
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 "ngrok-skip-browser-warning": "69420",
    //             }
    //         })
    //             .then((res) => {
    //                 if (res.data.success === true) {
    //                     setData(res.data.result);
    //                 }
    //                 else {
    //                     setErrOcc(true);
    //                     props.setLoading(false);
    //                 }
    //             })
    //             // Catch errors if any
    //             .catch((err) => {
    //                 console.warn(err);
    //                 setErrOcc(true);
    //                 props.setLoading(false);
    //             });
    //     }
    // }, []);

    useEffect(() => {
        const token = ReactSession.get("xTkn") ?? "";
        const isFree = ReactSession.get("ifr") ?? "unknown";
        if (isFree === "Free")
            props.setFreeUser(true)
        else
            props.setFreeUser(false)
        if (token !== "") {
            const endPoint = process.env.REACT_APP_AUTH_EP;
            axios({
                url: `${endPoint}dashboard/get_active_plans`,
                method: "GET",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    "ngrok-skip-browser-warning": "69420",
                }
            })
                .then((res) => {
                    if (res.data.success === true) {
                        setData(res.data.result);
                        setgRPCExpiry(res.data.result.filter(plan => plan.plan_name === "GRPC")[0]?.bill_details.cycle_end ?? "");
                        
                        const acceptedPlan = res.data.result.filter(plan => ACCEPT_PLANS.includes(plan.plan_name));
                        if (acceptedPlan.length > 0) {
                            setCardPlan(acceptedPlan[0]?.plan_name);
                        }
                    }
                    else {
                        setErrOcc(true);
                        props.setLoading(false);
                    }
                })
                // Catch errors if any
                .catch((err) => {
                    console.warn(err);
                    setErrOcc(true);
                    props.setLoading(false);
                });
        }
    }, []);

    useEffect(() => {
        if (data !== null)
            props.setLoading(false);
    }, [data]);

    const unshowCard = () => {
        setShowCancelCard(false);
        setPlanCancelled('');
        setPlanCancelName('');
        setReasons([]);

        setCancelInput("");
        setEnableCancelInput(false);
        setSelectProvider('');
        setTextProvider('');
        setShowProviderBox(false);
        setShowTextProviderBox(false);
        setIssueInput("");
        setEnableIssueInput(false);
        setFeatureInput("");
        setEnableFeatureInput(false);
    }
    const addRemoveReason = (reason) => {
        setReasons((reasons) => {
            if (reasons.includes(reason)) {
                return reasons.filter(i => i !== reason);
            } else {
                return [...reasons, reason];
            }
        });
    };

    const cancellationReasons = ["Stopped trading"];
    const grpcProviders = ["Helius", "Hellomoon", "QuickNode", "Solana Vibe Station", "Corvus", "ERPC"];


    return (
        <div>
            <Modal isOpen={showCancelCard} onClose={() => unshowCard()} blockScrollOnMount={true}>
                <ModalOverlay />
                <ModalContent bg={"brand.black"} border={"1px solid"} borderColor={"brand.midGrey"} borderRadius={"xl"}>
                
                <ModalCloseButton />
                <ModalBody py={4}>
                    <Text
                        as="div"
                        fontSize={{ base: "md", md: "md"}}
                        fontWeight={"600"}
                        color={"brand.white"}
                        textAlign={"center"}
                        fontFamily={"heading"}
                    >
                        Are you sure you want to cancel your <Text as="span" color={"brand.yellow"}>{planCancelName}</Text> plan? Please share your honest reason to help us improve our service.
                    </Text>
                    <Box pt={8}>
                        <Button
                            textAlign={"center"}
                            w={"100%"}
                            fontSize={"sm"}
                            fontWeight={"400"}
                            fontFamily={"heading"}
                            borderRadius={"lg"}
                            px={{ base: "12px", xl: "24px" }}
                            py={{ base: "6px", lg: "6px" }}
                            bg={showProviderBox ? "brand.red" : "transparent"}
                            border="2px solid"
                            borderColor="brand.red"
                            color={"brand.white"}
                            mb={2}
                            _hover={{
                                bg: "brand.red",
                            }}
                            onClick={() => {
                                setShowProviderBox(!showProviderBox)
                                setSelectProvider("");
                                setTextProvider("");
                                setShowTextProviderBox(false);
                            }}
                        >
                            Switching to another provider
                        </Button>
                        {showProviderBox && <Stack spacing={3}>
                            <Stack px={2} pb={12} pt={2} bg={"#000"}>
                                <Box>
                                    <Text
                                        as="div"
                                        fontSize={{ base: "md", md: "md"}}
                                        fontWeight={"600"}
                                        color={"brand.white"}
                                        textAlign={"center"}
                                        fontFamily={"heading"}
                                    >
                                        Please select the provider so we can improve and benchmark against them
                                    </Text>
                                </Box>
                                {grpcProviders.map ((provider) => <Box>
                                    <Button
                                        textAlign={"center"}
                                        w={"100%"}
                                        fontSize={"sm"}
                                        fontWeight={"400"}
                                        fontFamily={"heading"}
                                        borderRadius={"lg"}
                                        px={{ base: "12px", xl: "24px" }}
                                        py={{ base: "6px", lg: "6px" }}
                                        bg={selProvider === provider ? "brand.red" : "transparent"}
                                        border="2px solid"
                                        borderColor="brand.red"
                                        color={"brand.white"}
                                        mb={2}
                                        _hover={{
                                            bg: "brand.red",
                                        }}
                                        onClick={() => {
                                            setSelectProvider(provider)
                                            
                                        }}
                                    >
                                        {provider}
                                    </Button>
                                </Box>)
                                }
                                {<Box>
                                    <Button
                                        textAlign={"center"}
                                        w={"100%"}
                                        fontSize={"sm"}
                                        fontWeight={"400"}
                                        fontFamily={"heading"}
                                        borderRadius={"lg"}
                                        px={{ base: "12px", xl: "24px" }}
                                        py={{ base: "6px", lg: "6px" }}
                                        bg={showTextProviderBox ? "brand.red" : "transparent"}
                                        border="2px solid"
                                        borderColor="brand.red"
                                        color={"brand.white"}
                                        mb={2}
                                        _hover={{
                                            bg: "brand.red",
                                        }}
                                        onClick={() => {
                                            setSelectProvider("")
                                            setShowTextProviderBox(true)
                                        }}
                                    >
                                        Other

                                     </Button>
                                </Box>}
                                {showTextProviderBox && <Input variant='flushed' placeholder='Please enter the provider name' color={"brand.white"} focusBorderColor="brand.midGrey" errorBorderColor="brand.red" value={textProvider} onChange={(e) => setTextProvider(e.target.value)} minLength={3} maxLength={100}/>}
                            </Stack>                    
                        </Stack>}
                        {cancellationReasons.map((reason, index) => (<Button
                            key={index}
                            textAlign={"center"}
                            w={"100%"}
                            fontSize={"sm"}
                            fontWeight={"400"}
                            fontFamily={"heading"}
                            borderRadius={"lg"}
                            px={{ base: "12px", xl: "24px" }}
                            py={{ base: "6px", lg: "6px" }}
                            bg={reasons.includes(reason) ? "brand.red" : "transparent"}
                            border="2px solid"
                            borderColor="brand.red"
                            color={"brand.white"}
                            mb={2}
                            _hover={{
                                bg: "brand.red",
                            }}
                            onClick={() => addRemoveReason(reason)}
                        >
                            {reason}
                        </Button>))}
                        <Button
                            textAlign={"center"}
                            w={"100%"}
                            fontSize={"sm"}
                            fontWeight={"400"}
                            fontFamily={"heading"}
                            borderRadius={"lg"}
                            px={{ base: "12px", xl: "24px" }}
                            py={{ base: "6px", lg: "6px" }}
                            bg={enableFeatureInput ? "brand.red" : "transparent"}
                            border="2px solid"
                            borderColor="brand.red"
                            color={"brand.white"}
                            mb={2}
                            _hover={{
                                bg: "brand.red",
                            }}
                            onClick={() => setEnableFeatureInput(!enableFeatureInput)}
                        >
                            Missing Feature
                        </Button>
                        {enableFeatureInput && <Stack spacing={3} mb={"24px"} mt={"8px"}>                    
                            <Input variant='flushed' placeholder='Please share the feature you were looking for...' color={"brand.white"} focusBorderColor="brand.midGrey" errorBorderColor="brand.red" value={featureInput} onChange={(e) => setFeatureInput(e.target.value)} minLength={3} maxLength={100}/>
                        </Stack>}
                        <Button
                            textAlign={"center"}
                            w={"100%"}
                            fontSize={"sm"}
                            fontWeight={"400"}
                            fontFamily={"heading"}
                            borderRadius={"lg"}
                            px={{ base: "12px", xl: "24px" }}
                            py={{ base: "6px", lg: "6px" }}
                            bg={enableIssueInput ? "brand.red" : "transparent"}
                            border="2px solid"
                            borderColor="brand.red"
                            color={"brand.white"}
                            mb={2}
                            _hover={{
                                bg: "brand.red",
                            }}
                            onClick={() => setEnableIssueInput(!enableIssueInput)}
                        >
                            Product/Performance Issue
                        </Button>
                        {enableIssueInput && <Stack spacing={3} mb={"24px"} mt={"8px"}>                    
                            <Input variant='flushed' placeholder='Please tell us a bit more about the issue...' color={"brand.white"} focusBorderColor="brand.midGrey" errorBorderColor="brand.red" value={issueInput} onChange={(e) => setIssueInput(e.target.value)} minLength={3} maxLength={100}/>
                        </Stack>}
                        <Button
                            textAlign={"center"}
                            w={"100%"}
                            fontSize={"sm"}
                            fontWeight={"400"}
                            fontFamily={"heading"}
                            borderRadius={"lg"}
                            px={{ base: "12px", xl: "24px" }}
                            py={{ base: "6px", lg: "6px" }}
                            bg={enableCancelInput ? "brand.red" : "transparent"}
                            border="2px solid"
                            borderColor="brand.red"
                            color={"brand.white"}
                            mb={2}
                            _hover={{
                                bg: "brand.red",
                            }}
                            onClick={() => setEnableCancelInput(!enableCancelInput)}
                        >
                            Other
                        </Button>
                        {enableCancelInput && <Stack spacing={3}>                    
                            <Input variant='flushed' placeholder='Please share your reason to help us improve' color={"brand.white"} focusBorderColor="brand.midGrey" errorBorderColor="brand.red" value={cancelInput} onChange={(e) => setCancelInput(e.target.value)} minLength={3} maxLength={100}/>
                        </Stack>}
                    </Box>
                    <Text
                        as="div"
                        fontSize={{ base: "xs", md: "xs" }}
                        fontWeight={"400"}
                        color={"brand.white"}
                        textAlign={"start"}
                        mt={4}
                        
                    >
                        Note: The plan will be valid till the end of the billing cycle, no further charges will be deducted.
                    
                    </Text>
                </ModalBody>
                    <ModalFooter>
                        {cancelStatus === "NO_ACTION" && <Flex width={"100%"} justifyContent={"center"}>
                            <Button colorScheme='blue' mr={3} onClick={() => cancelPlanNow(planCancelled)}
                                color={"brand.dark"}
                                bg={"brand.white"}
                                _hover={{
                                  bg: "brand.black",
                                  color: "brand.white",
                                }}
                                px={"20px"}
                                fontFamily={"heading"}
                                fontSize={"12px"}
                                lineHeight={"12px"}
                                size={"sm"}
                                borderRadius={"full"}
                                isDisabled={(reasons.length === 0 && cancelInput.length < 6 && featureInput.length < 4 && issueInput.length < 5 && textProvider.length < 3 && selProvider === '') ? true : false}    
                            >
                                Yes
                            </Button>
                            <Button colorScheme='blue' mr={3} onClick={() => unshowCard()}
                                color={"brand.dark"}
                                bg={"brand.white"}
                                _hover={{
                                  bg: "brand.black",
                                  color: "brand.white",
                                }}
                                px={"20px"}
                                fontFamily={"heading"}
                                fontSize={"12px"}
                                lineHeight={"12px"}
                                size={"sm"}
                                borderRadius={"full"}    
                            >
                                No
                            </Button>
                        </Flex>}
                        {cancelStatus === "CANCELLING" && <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                            <BeatLoader color="#fff" loading={true} size={10} />
                        </Flex>}
                        {cancelStatus === "CANCELLED" && <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                            <FaCheck color="#39e75f"/>
                        </Flex>}
                        {cancelStatus === "NOT_CANCELLED" && <Flex w={"100%"} justifyContent={"center"} height={"24px"}>
                            <ImCross color="#e3242b"/>
                        </Flex>}
                        
                    </ModalFooter>
                </ModalContent>
            </Modal>
            {(!props.isLoading && (data !== null)) && 
                <Container maxW={"8xl"}>
                <Box
                    as="div"
                >
                    <Box>
                        <Text
                            as={'div'}
                            fontFamily={'heading'}
                            color={'brand.white'}
                            fontSize={'2xl'}
                            lineHeight={'3xl'}
                            fontWeight={'600'}
                        >
                            Billing Overview
                        </Text>
                    </Box>
                </Box>
                
                <Box>
                    {Array.isArray(data) && data.map((plan) => (
                        (plan.plan_name !== "FREE") ? (plan.plan_name === "GRPC") ?
                        <Stack direction={{ base: 'column', lg: 'row' }} mt={6} spacing={0.5}>
                            <Box
                                width={{ base: '100%', lg: '80%' }}
                                bg={'black'}
                                borderTopLeftRadius={'2xl'}
                                borderBottomLeftRadius={'2xl'}
                                borderTopRightRadius={{base: '2xl', lg: "0px"}}
                                borderBottomRightRadius={{base: '2xl', lg: "0px"}}
                                px={{base: 6, md: 8}}
                                pt={{base: 4, md: 3}}
                                pb={{base: 4, md: 4}}
                            >
                                <Flex justifyContent={'space-between'} alignItems={'center'} mt={4} fontSize={{ base: '14px', lg: 'md' }}>
                                    <Text as={'div'} color={'brand.white'}>Plan Name</Text>
                                    <Text as={'div'} color={'brand.yellow'} fontFamily={'heading'}>
                                        {plan.plan_name ?? "gRPC Service"}
                                    </Text>
                                </Flex>
                                <Flex justifyContent={'space-between'} alignItems={'center'} mt={{base: 0, lg: 4}} fontSize={{ base: '14px', lg: 'md' }}>
                                    <Text as={'div'} color={'brand.white'}>{(plan?.is_on_trial)?"Trial Period":"Billing Cycle"}</Text>
                                    <Text as={'div'} color={'brand.yellow'} fontFamily={'heading'}>
                                        {new Date(plan.bill_details.cycle_start).getDate()}{' '}
                                        {months[new Date(plan.bill_details.cycle_start).getUTCMonth()]}{' '}
                                        {new Date(plan.bill_details.cycle_start).getUTCFullYear()} -{' '}
                                        {new Date(plan.bill_details.cycle_end).getUTCDate()}{' '}
                                        {months[new Date(plan.bill_details.cycle_end).getUTCMonth()]}{' '}
                                        {new Date(plan.bill_details.cycle_end).getUTCFullYear()}
                                    </Text>
                                </Flex>
                                <Flex justifyContent={'space-between'} alignItems={'center'} mt={4} fontSize={{ base: '14px', lg: 'md' }}>
                                    <Text as={'div'} color={'brand.white'}>IPs Allowed</Text>
                                    <Text as={'div'} color={'brand.yellow'} fontFamily={'heading'}>
                                       {plan.bill_details.max_ips_allowed}
                                    </Text>
                                </Flex>
                                
                            </Box>
                            <Box
                                width={{ base: '100%', lg: '20%' }}
                                bg={'black'}
                                borderTopRightRadius={'2xl'}
                                borderBottomRightRadius={'2xl'}
                                borderTopLeftRadius={{base: '2xl', lg: "0px"}}
                                borderBottomLeftRadius={{base: '2xl', lg: "0px"}}
                                px={4}
                                py={{base: 4, lg: 6}}
                                
                            >
                                <Flex flexDirection={{sm: "row", lg: "column"}} justifyContent={'space-between'} alignItems={'center'} mt={{base: 0, lg: 1}}>
                                    <Box>
                                        <Text
                                            as={'div'}
                                            fontSize={{ base: '3xl', lg: '4xl' }}
                                            lineHeight={{ base: 1, lg: 1.1 }}
                                            color={'brand.red'}
                                            fontWeight={'600'}
                                            textAlign={{base: 'start', lg: 'center'}}
                                        >
                                            {plan.bill_details.currency === 'inr' ? '₹' : '$'}
                                            {plan.bill_details.amount_payable.usd ?? '--'}
                                        </Text>
                                        {(plan?.is_on_trial)?<Box>
                                            <Text as={'div'} color={'brand.white'} textAlign={'start'} fontSize={{ base: '11px', lg: '13px' }}>
                                                {(plan.cancel_at_cycle_end)?"Trial cancels at ":"Billing starts after"} {new Date(plan.bill_details.cycle_end).getUTCDate()}{' '}
                                                {months[new Date(plan.bill_details.cycle_end).getUTCMonth()]}{' '}
                                                {new Date(plan.bill_details.cycle_end).getUTCFullYear()}
                                            </Text>
                                        </Box>:
                                        <Text as={'div'} color={'brand.white'} textAlign={'center'} fontSize={{ base: '11px', lg: '13px' }}>
                                            {(plan.cancel_at_cycle_end)?"Cancels ":"Auto renews "} on {new Date(plan.bill_details.cycle_end).getUTCDate()}{' '}
                                                {months[new Date(plan.bill_details.cycle_end).getUTCMonth()]}{' '}
                                                {new Date(plan.bill_details.cycle_end).getUTCFullYear()}
                                        </Text>}
                                        
                                        
                                    </Box>
                                    <Box>
                                        <Box mt={{base: "0px", lg: "14px"}} mb={{base: "0px", lg: "10px"}}  textAlign={'center'}>
                                            {!plan.cancel_at_cycle_end && <Button
                                                borderRadius={'full'}
                                                bg={'brand.red'}
                                                color="brand.white"
                                                _hover={{ bg: 'brand.white', color: 'brand.red' }}
                                                px={{base: "16px", lg: "20px"}}
                                                fontSize={{base: "10px", lg: "14px"}}
                                                height={{base: "24px", lg: "30px"}}
                                                mx={"auto"}
                                                onClick={() => {
                                                    setPlanCancelled(plan.plan_id);
                                                    setPlanCancelName(plan.plan_name);
                                                    setShowCancelCard(true);
                                                }} 
                                            >
                                                Cancel {(plan?.is_on_trial)?"trial":"Subscription"}
                                            </Button>} 
                                        </Box>
                                    </Box>
                                </Flex>
                            </Box>
                        </Stack>
                        : 
                        (plan.plan_name === "JUPITER")?"":<Stack direction={{ base: 'column', lg: 'row' }} mt={6} spacing={0.5}>
                            <Box
                                width={{ base: '100%', lg: '80%' }}
                                bg={'black'}
                                borderTopLeftRadius={'2xl'}
                                borderBottomLeftRadius={'2xl'}
                                borderTopRightRadius={{base: '2xl', lg: "0px"}}
                                borderBottomRightRadius={{base: '2xl', lg: "0px"}}
                                px={{base: 6, md: 8}}
                                pt={{base: 4, md: "4px"}}
                                pb={{base: 4, md: "24px"}}
                            >
                                <Flex justifyContent={'space-between'} alignItems={'center'} mt={4} fontSize={{ base: '14px', lg: 'md' }}>
                                    <Text as={'div'} color={'brand.white'}>Plan Name</Text>
                                    <Text as={'div'} color={'brand.yellow'} fontFamily={'heading'}>
                                        {plan.plan_name ?? "--"}
                                        {(plan?.billing_interval && plan?.billing_interval > 1) && <Badge bg={"green.800"} color={"green.200"} fontWeight={"semibold"} ms={1} mt={-1} fontSize={"xs"} fontFamily={"body"} textTransform={"lowercase"}>{plan.billing_interval} Month</Badge>}
                                    </Text>
                                </Flex>
                                <Flex justifyContent={'space-between'} alignItems={'center'} mt={{base: 0, lg: 4}} fontSize={{ base: '14px', lg: 'md' }}>
                                    <Text as={'div'} color={'brand.white'}>Billing Cycle</Text>
                                    {plan?.plan_period?.plan_start && plan?.plan_period?.plan_start?<Text as={'div'} color={'brand.yellow'} fontFamily={'heading'}>
                                    {new Date(plan?.plan_period?.plan_start).getDate()}{' '}
                                        {months[new Date(plan?.plan_period?.plan_start).getUTCMonth()]}{' '}
                                        {new Date(plan?.plan_period?.plan_start).getUTCFullYear()} -{' '}
                                        {new Date(plan?.plan_period?.plan_end).getUTCDate()}{' '}
                                        {months[new Date(plan?.plan_period?.plan_end).getUTCMonth()]}{' '}
                                        {new Date(plan?.plan_period?.plan_end).getUTCFullYear()}
                                    </Text>: <Text as={'div'} color={'brand.yellow'} fontFamily={'heading'}>
                                    {new Date(plan.bill_details.cycle_start).getDate()}{' '}
                                        {months[new Date(plan.bill_details.cycle_start).getUTCMonth()]}{' '}
                                        {new Date(plan.bill_details.cycle_start).getUTCFullYear()} -{' '}
                                        {new Date(plan.bill_details.cycle_end).getUTCDate()}{' '}
                                        {months[new Date(plan.bill_details.cycle_end).getUTCMonth()]}{' '}
                                        {new Date(plan.bill_details.cycle_end).getUTCFullYear()}
                                    </Text>}
                                </Flex>
                                <Flex justifyContent={'space-between'} alignItems={'center'} mt={4} fontSize={{ base: '14px', lg: 'md' }}>
                                    <Text as={'div'} color={'brand.white'}>Credits Used</Text>
                                    <Text as={'div'} color={'brand.yellow'} fontFamily={'heading'}>
                                        {plan.bill_details.credit_used ?? "--"} Credits
                                    </Text>
                                </Flex>
                                <Flex justifyContent={'space-between'} alignItems={'center'} mt={4} fontSize={{ base: '14px', lg: 'md' }}>
                                    <Text as={'div'} color={'brand.white'}>Next Invoice</Text>
                                    
                                    {(plan?.plan_period?.plan_end)?<Text as={'div'} color={'brand.yellow'} fontFamily={'heading'} textAlign={'center'}>
                                            {"Expires "} on {new Date(plan?.plan_period?.plan_end).getUTCDate()}{' '}
                                                {months[new Date(plan?.plan_period?.plan_end).getUTCMonth()]}{' '}
                                                {new Date(plan?.plan_period?.plan_end).getUTCFullYear()}
                                        </Text>:
                                        plan.subscription_cycle?.period_end ? (
                                        <Text as={'div'} color={'brand.yellow'} fontFamily={'heading'} textAlign={'center'} >
                                            {(plan.subscription_cycle?.cancel_at_period_end) ? "No further charges. Cancels on " : ""}  {new Date(plan.subscription_cycle.period_end).getUTCDate()}{' '}
                                                {months[new Date(plan.subscription_cycle.period_end).getUTCMonth()]}{' '}
                                                {new Date(plan.subscription_cycle.period_end).getUTCFullYear()}
                                        </Text>) : "--"}
                                </Flex>
                            </Box>
                            <Box
                                width={{ base: '100%', lg: '20%' }}
                                bg={'black'}
                                borderTopRightRadius={'2xl'}
                                borderBottomRightRadius={'2xl'}
                                borderTopLeftRadius={{base: '2xl', lg: "0px"}}
                                borderBottomLeftRadius={{base: '2xl', lg: "0px"}}
                                px={4}
                                pb={{base: 4, lg: 2}}
                                pt={{base: 4, lg: 12}}
                                
                            >
                                <Flex flexDirection={{sm: "row", lg: "column"}} justifyContent={'space-between'} alignItems={'center'} mt={{base: 0, lg: 0}}>
                                    <Box>
                                        <Text
                                            as={'div'}
                                            fontSize={{ base: '3xl', lg: '4xl' }}
                                            lineHeight={{ base: 1, lg: 1.1 }}
                                            color={'brand.red'}
                                            fontWeight={'600'}
                                            textAlign={{base: 'start', lg: 'center'}}
                                        >
                                            {plan.bill_details.currency === 'inr' ? '₹' : '$'}
                                            {plan.bill_details.amount_payable ?? '--'}
                                        </Text>
                                        {/* {(plan?.plan_period?.plan_end)?<Text as={'div'} color={'brand.white'} textAlign={'center'} fontSize={{ base: '11px', lg: '13px' }}>
                                            {"Expires "} on {new Date(plan?.plan_period?.plan_end).getUTCDate()}{' '}
                                                {months[new Date(plan?.plan_period?.plan_end).getUTCMonth()]}{' '}
                                                {new Date(plan?.plan_period?.plan_end).getUTCFullYear()}
                                        </Text>:<Text as={'div'} color={'brand.white'} textAlign={'center'} fontSize={{ base: '11px', lg: '13px' }}>
                                            {(plan.cancel_at_cycle_end)?"Cancels ":"Auto renews "} on {new Date(plan.bill_details.cycle_end).getUTCDate()}{' '}
                                                {months[new Date(plan.bill_details.cycle_end).getUTCMonth()]}{' '}
                                                {new Date(plan.bill_details.cycle_end).getUTCFullYear()}
                                        </Text>} */}
                                    </Box>
                                    <Box>
                                        <Box mt={{base: "0px", lg: "14px"}} textAlign={'center'}>
                                            {!plan.cancel_at_cycle_end && <Button
                                                borderRadius={'full'}
                                                bg={'brand.red'}
                                                color="brand.white"
                                                _hover={{ bg: 'brand.white', color: 'brand.red' }}
                                                px={{base: "16px", lg: "20px"}}
                                                fontSize={{base: "10px", lg: "14px"}}
                                                height={{base: "24px", lg: "30px"}}
                                                mx={"auto"}
                                                onClick={() => {
                                                    setPlanCancelled(plan.plan_id);
                                                    setPlanCancelName(plan.plan_name);
                                                    setShowCancelCard(true);
                                                }} 
                                            >
                                                Cancel Subscription
                                            </Button>} 
                                        </Box>
                                    </Box>
                                </Flex>
                            </Box>
                        </Stack> : ""
                    ))}
                    
                </Box>
                {((Array.isArray(data) && data.length === 0) || (Array.isArray(data) && data.filter((plan) => plan.plan_name !== "FREE")?.length === 0))  && <Box>
                    <Box w={'full'} fontSize={{base: '14px', lg: 'md'}} bg={'black'} pt={4} pb={2} px={6} borderRadius={'lg'} mt={4}>
                        <Text as={'div'} color={'brand.white'} mb={2}>You are on <em>Free Plan</em>. No Active Subscriptions Found.</Text>
                        {/* <Text as={'div'} color={'brand.grey'}>Select a plan from <em>Pricing</em> to add card.</Text> */}
                    </Box>
                </Box>}
                {(data?.filter((plan) => plan.plan_name === "GRPC")[0]?.is_on_trial) && (gRPCExpiry!="") && <Text as={'div'} color={'brand.midGrey'} fontSize={{base: '14px', lg: '14px'}} pt={'5'} ps={'1'}>
                    gRPC billing starts from 
                    {' '}<Text as={"span"} color={"brand.yellow"}>{months[new Date(gRPCExpiry).getUTCMonth()]}{' '}{new Date(gRPCExpiry).getUTCDate()}{', '}
                                                {new Date(gRPCExpiry).getUTCFullYear()}</Text>. If the plan is cancelled during the trial period, no charges will be incurred.
                </Text>}
                {errorWhileCancelPlan && <Box px={4} bgColor={"#8B0000"} mt={6} borderRadius={'lg'}>
                    <Text as={'div'} color={'brand.white'} fontSize={{base: '14px', lg: '14px'}} py={'3'} ps={'1'} fontWeight={'600'}>
                        Some error occurred. To cancel your subscription, please reach out to us on Dashboard Support or <Text as={'a'} href={linksConfig.DISCORD_LINK} target="_blank" rel="noopener noreferrer" color={'brand.yellow'} _hover={{ color: "brand.red" }}>Discord</Text>.
                    </Text>
                </Box>}
                
                <Box as="div" mt={8}>
                    <Box>
                        <Text
                            as={'div'}
                            fontFamily={'heading'}
                            color={'brand.white'}
                            fontSize={'2xl'}
                            lineHeight={'3xl'}
                            fontWeight={'600'}
                        >
                            Payment method
                        </Text>
                        <Text as={'div'} color={'brand.white'} fontSize={{base: '14px', lg: 'md'}} pt={'1'}>
                            Your last payment method details
                        </Text>
                        {(userCards.length > 0) && userCards.map((card) => <Box key={card.id} mt={6}>
                            <Box
                                bg={'black'}
                                borderRadius={'2xl'}
                                px={{ base: '16px', lg: '32px' }}
                                pt={{ base: '16px', lg: '24px' }}
                                pb={{ base: '36px', lg: '28px' }}
                                mt={4}
                            >
                                <Flex
                                    direction={{base: 'column', lg: "row"}}
                                    justifyContent={{ base: 'center', lg: 'space-between' }}
                                    alignItems={'center'}
                                >
                                    <Box w={'full'} maxW="400px">
                                        <Text as={'div'} color={'brand.white'}>{card.card.brand.toUpperCase()}</Text>
                                        <HStack color={'brand.white'} fontSize={{ base: 'xs', lg: 'sm' }} mt={2}>
                                            <Box w={'49%'} textAlign={'left'}>
                                                Card Number
                                            </Box>
                                            <Box w={'49%'} textAlign={'right'}>
                                                ***** {card.card.last4}
                                            </Box>
                                        </HStack>
                                        <HStack color={'brand.white'} fontSize={{ base: 'xs', lg: 'sm' }} mt={2}>
                                            <Box w={'49%'} textAlign={'left'}>
                                                Expiry
                                            </Box>
                                            <Box w={'49%'} textAlign={'right'}>
                                                {card.card.exp_month}/{card.card.exp_year}
                                            </Box>
                                        </HStack>
                                    </Box>
                                    <Box mt={{base: "0px", lg: "0px"}}>
                                        {/* <Button
                                            borderRadius={'full'}
                                            bg={'brand.red'}
                                            color="brand.white"
                                            _hover={{ bg: 'brand.white', color: 'brand.red' }}
                                            px={{base: "20px", lg: "32px"}}
                                            isLoading={(card.id === cardCancelled)}
                                            spinner={<BeatLoader size={8} color='white' />}
                                            onClick={() => removeCard(card.id)}
                                            fontSize={{base: "14px", lg: "16px"}}
                                        >
                                            Remove Card
                                        </Button> */}
                                        <Button
                                            borderRadius={'full'}
                                            bg={'brand.red'}
                                            color="brand.white"
                                            _hover={{ bg: 'brand.white', color: 'brand.red' }}
                                            px={{base: "16px", lg: "20px"}}
                                            fontSize={{base: "10px", lg: "14px"}}
                                            height={{base: "24px", lg: "30px"}}
                                            mx={"auto"}
                                            isLoading={cardUpdateLoading}
                                            spinner={<BeatLoader size={8} color='white' />}
                                            onClick={() => {updatePaymentMethod(cardPlan)}}
                                        >
                                            Change Card
                                        </Button>
                                        
                                    </Box>
                                </Flex>
                            </Box>
                        </Box>)}
                        {(userCards.length < 1) && <Box
                            bg={'black'}
                            borderRadius={'2xl'}
                            px={{ base: '22px', lg: '32px' }}
                            pt={{ base: '16px', lg: '24px' }}
                            pb={{ base: '16px', lg: '28px' }}
                            mt={6}
                        >
                            
                                <Box w={'full'} maxW="400px" fontSize={{base: '14px', lg: 'md'}}>
                                    <Text as={'div'} color={'brand.white'} mb={2}>No cards found.</Text>
                                    <Text as={'div'} color={'brand.grey'}>Select a plan from <em>Pricing</em> to add card.</Text>
                                </Box>
                                
                        </Box>}
                        {cardUpdateError === "" && <Text as={'div'} color={'brand.midGrey'} fontSize={{base: '14px', lg: '14px'}} pt={'5'} ps={'1'}>
                            Please reach out to us on Dashboard Support or <Text as={'a'} href={linksConfig.DISCORD_LINK} target="_blank" rel="noopener noreferrer" color={'brand.yellow'} _hover={{ color: "brand.red" }}>Discord</Text>, in case of any issue(s) with your billing.
                        </Text>}
                        {(cardUpdateError === "ERROR" || cardUpdateError === "NO_PLAN")&& <Text as={'div'} color={'brand.red'} fontSize={{base: '14px', lg: '14px'}} pt={'5'} ps={'1'}>
                            Some Error Occured, Please reach out to us on Dashboard Support or <Text as={'a'} href={linksConfig.DISCORD_LINK} target="_blank" rel="noopener noreferrer" color={'brand.yellow'} _hover={{ color: "brand.red" }}>Discord</Text>.
                        </Text>}
                    </Box>
                </Box>
            </Container>}
        </div>
    );
}

export default Billings;